<div class="container-fluid" [ngClass]="!theme ? 'dark-theme' : ''">
    <div class="row">
        <div class="col-sm-12 p-0">
            <div class="card mb-0 border-0">
                <div class="card-body p-0">
                    <div class="profile-bg  position-relative">
                        <div class="bg-overlay p-48">
                            <h1 class="txt-blue txt-heading mb-2">Settings</h1>
                            <p class="mb-0 txt-blue fs-16">Account Information</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-4 profile-wrapper">
            <div class="card profile-card">
                <div class="card-body p-0 text-center">
                    <div class="p-2">
                        <div class="m-auto circle mb-2"
                            [ngStyle]="{'background-color':  circleColor }">
                            <div class="initials">
                                {{ initials }}
                            </div>
                        </div>
                        <!-- <div class="aavtar m-auto">
                            <img src="assets/images/avatar-2.png" alt="" class="rounded-circle">
                        </div> -->
                        <h2 class="txt-gray text-center fw-bold">{{userData.first_name}}
                            {{userData.last_name}}</h2>
                        <!-- <div class="credits">
                            <i class="bi bi-credit-card txt-gray fs-16 pe-2"></i>
                            <span class="txt-gray credit-txt">Available Credits :<b class="fw-bold fs-16 ps-1">{{userData.credit}}/{{userData.max_credit}}</b></span>
                        </div> -->
                        <div class="credits py-1">
                            <!-- <i class="bi bi-credit-card txt-gray fs-16 pe-2"></i> -->
                            <span class="txt-gray credit-txt">Audit/Content
                                Editor:<b class="fw-bold fs-16 ps-1">{{userData.credit}}
                                    / {{userData.max_credit == 'inf' ? 'inf' :
                                    userData.max_credit}}</b><span
                                    class="remaining"> {{userData.max_credit ==
                                    'inf' ? 'inf' : userData.max_credit -
                                    userData.credit}} remaining </span></span>
                        </div>
                        <div class="credits py-1">
                            <!-- <i class="bi bi-credit-card txt-gray fs-16 pe-2"></i> -->
                            <span class="txt-gray credit-txt">Keyword Reports :<b
                                    class="fw-bold fs-16 ps-1">
                                    {{userData.kw_credit}} /
                                    {{userData.kw_max_credit}}</b><span
                                    class="remaining"> {{userData.kw_max_credit
                                    - userData.kw_credit}} remaining </span></span>
                        </div>
                        <div class="credits py-1">
                            <!-- <i class="bi bi-credit-card txt-gray fs-16 pe-2"></i> -->
                            <span class="txt-gray credit-txt">SERP Credits :<b
                                    class="fw-bold fs-16 ps-1">{{userData.serp_credit}}
                                    / {{userData.serp_max_credit}}</b><span
                                    class="remaining">
                                    {{userData.serp_max_credit -
                                    userData.serp_credit}} remaining </span></span>
                        </div>
                    </div>
                    <div
                        class="d-flex border-top p-2 align-items-center justify-content-end">
                        <!-- <div class="flex-grow-1">
                            <span class="credits-remainig p-2">{{userData.max_credit - userData.credit}} remaining</span>
                        </div> -->
                        <!-- <div class="flex-shrink-0">
                            <button type="button" class="btn btn-primary btn-sm">
                                <img src="assets/images/add.png" alt="" height="16" width="16">
                                Upgrade Plan</button>
                        </div> -->
                    </div>

                </div>
            </div>
        </div>

        <div class="col-sm-8 my-4">
            <div class="card profile-card">
                <div class="card-body p-0">
                    <h2 class="txt-black p-3">About</h2>

                    <div class="border-bottom mb-3 pb-2">
                        <div
                            class="d-flex px-3 align-items-center justify-content-between">
                            <p class="mb-0 detail-left col-8">Email</p>
                            <p class="mb-0 detail-right col-4">{{userData.email}}</p>
                        </div>
                    </div>

                    <div class="border-bottom mb-3 pb-2">
                        <div class="d-flex px-3 align-items-center">
                            <p class="mb-0 detail-left col-8">Last Login</p>
                            <p class="mb-0 detail-right col-4">{{userData.last_login
                                | date : 'd MMM,y'}} {{userData?.last_login |
                                date
                                :
                                'HH:mm a'}}</p>
                        </div>
                    </div>

                    <div class="border-bottom mb-3 pb-2">
                        <div class="d-flex px-3 align-items-center">
                            <p class="mb-0 detail-left col-8">Date Joined</p>
                            <p class="mb-0 detail-right col-4">
                                {{userData?.date_joined | date : 'd MMM,y'}}
                                {{userData?.date_joined | date
                                :
                                'HH:mm a'}}</p>
                        </div>
                    </div>

                    <div class="border-bottom mb-3 pb-2">
                        <div class="d-flex px-3 align-items-center">
                            <p class="mb-0 detail-left col-8">Account Type</p>
                            <p class="mb-0 detail-right col-4">{{userData?.subscription_name
                                == '' ? 'Free' : userData?.subscription_name }}</p>
                        </div>
                    </div>

                    <!-- <div class="border-bottom mb-3 pb-2">
                        <div class="d-flex px-3 align-items-center">
                            <p class="mb-0 detail-left col-8">Monthly Available Credits</p>
                            <p class="mb-0 detail-right col-4">{{userData.max_credit}}</p>
                        </div>
                    </div> -->

                    <!-- <div class="border-bottom mb-3 pb-2">
                        <div class="d-flex px-3 align-items-center">
                            <p class="mb-0 detail-left col-8">Audit/Content Editor</p>
                            <p class="mb-0 detail-right col-4">  {{userData.max_credit == 'inf' ? userData.max_credit : userData.max_credit - userData.credit}} / {{userData.max_credit}}</p>
                        </div>
                    </div> -->

                    <!-- <div class="border-bottom mb-3 pb-2">
                        <div class="d-flex px-3 align-items-center">
                            <p class="mb-0 detail-left col-8">Keyword Reports</p>
                            <p class="mb-0 detail-right col-4"> {{userData.kw_max_credit - userData.kw_credit}} / {{userData.kw_max_credit}} </p>
                        </div>
                    </div>

                    <div class="border-bottom mb-3 pb-2">
                        <div class="d-flex px-3 align-items-center">
                            <p class="mb-0 detail-left col-8">SERP Credits</p>
                            <p class="mb-0 detail-right col-4"> {{userData.serp_max_credit - userData.serp_credit}} / {{userData.serp_max_credit}} </p>
                        </div>
                    </div> -->

                    <div class=" mb-3 pb-2">
                        <div class="d-flex px-3 align-items-center">
                            <p class="mb-0 detail-left col-8">Credit Reset Date</p>
                            <p class="mb-0 detail-right col-4">{{userData.date_pay
                                | date : 'd MMM,y'}} {{userData?.date_pay | date
                                :
                                'HH:mm a'}} </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12 mb-4">
            <div class="card profile-card">
                <div class="card-body">
                    <h2 class="txt-black">Change Password</h2>
                    <div class="row mb-4">
                        <div class="col-sm-5">
                            <input type="password" placeholder="Password"
                                class="form-control input"
                                [(ngModel)]="password">
                        </div>
                    </div>

                    <div class="row mb-4">
                        <div class="col-sm-5">
                            <input type="password"
                                placeholder="Confirm Password"
                                class="form-control input"
                                [(ngModel)]="cPassword">
                        </div>
                    </div>
                    <button class="btn btn-primary" (click)="resetPassword()"
                        [disabled]="password =='' || cPassword==''">Reset
                        Password</button>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="row">
        <div class="col-sm-12 mb-lg-4">
            <div class="card profile-card">
                <div class="card-body">
                    <h2 class="txt-black">Integrations</h2>
                    <mat-accordion>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header style="background-color: #ece6e6;" >
                                <mat-panel-title>
                                  WordPress
                                </mat-panel-title>
                                <mat-panel-description>
                                    <span class="m-auto" ></span>
                                   <div><button class="btn btn-success" *ngIf="intregtedAccount.length != 0">Connected</button></div>
                                   <div><button class="btn btn-primary" *ngIf="intregtedAccount.length == 0">Connect</button></div>
                                </mat-panel-description>
                              </mat-expansion-panel-header>
                            <div style="padding: 10px;margin: 5px;" >
                                <div>
                                    <p style="border: 1px solid #000;padding: 6px;background: aliceblue;border-radius: 5px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style="width:20px" class="h-5 w-5 text-blue-400"><path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd"></path></svg>
                                        You must link a user that has an Author, Editor, or
                                        Admin role. We recommend using the Editor or Admin
                                        role because some functionality will not work
                                        perfectly with an Author. Also, you must use an
                                        Application Password, not a regular password. You
                                        can easily create an Application Password on the
                                        Profile page or when editing a User in the WordPress
                                        Admin (view video here). For the domain you must
                                        only include the domain name such as "google.com"
                                        and not "https://google.com/"</p>
                                    <div class="mt-4">
                                        <div>
                                            <label for="website" class><strong>WordPress
                                                    Site Domain</strong></label>
                                            <div class="mt-2 d-flex">
                                                <span style="background: #dde0e3;padding: 15px">https://</span>
                                                <input class="form-control"
                                                    type="text" [(ngModel)]="wbSite"
                                                    placeholder="google.com">
                                            </div>
                                            <p class="mt-3 text-sm text-gray-400">Make sure
                                                your site does not block the built-in
                                                WordPress REST API. At a minimum, the
                                                "/wp-json/wp/v2/posts" endpoint must be
                                                accessible.</p>
                                        </div>
                                        <div class="mt-4"><label for="username"><strong>WordPress
                                                    Username</strong></label>
                                            <div class="mt-2">
                                                <input style="padding: 14px 12px;" class="form-control"
                                                    type="text" placeholder="superuser"
                                                    [(ngModel)]="wordPressUserName">
                                            </div>
                                            <p class="mt-3 text-sm text-gray-400">You must
                                                use the username of a WordPress user with
                                                Author, Editor, or Admin roles. Do not use
                                                the name of the Application Password. We
                                                recommend using the Editor or Admin role
                                                because some functionality will not work
                                                perfectly with an Author.</p>
                                        </div>
                                        <div class="mt-4">
                                            <label><strong>WordPress
                                                    Application Password</strong></label>
                                            <div class="mt-2">
                                                <input style="padding: 14px 12px;" class="form-control"
                                                    [(ngModel)]="password2" placeholder="ABCD EFGH IJKL MNOP"
                                                    type="password">
                                            </div>
                                            <p class="mt-3 text-sm text-gray-400">This must
                                                be an Application Password - not the regular
                                                password that is used to login! It looks
                                                like this: "E66J cCGF vxcM eraH PtLD 66X1".
                                                See the message above for more information
                                                on how to create one.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="px-5">
                                    <button class="btn btn-primary ml-4" [disabled]="wbSite == '' || wordPressUserName == '' || password2 == ''"
                                        (click)="addAccount()"  >Confirm</button>
                                </div>
                            </div><br><br>
                            <div *ngIf="intregtedAccount.length != 0" >
                                <div class="mb-4 d-flex justify-content-between" *ngFor="let i of intregtedAccount"  style="    align-items: center;background-color: #ece6e6;margin: 0px 15px;padding: 7px;" >
                                    <span>{{i.webSite}}</span>
                                    <span>{{i.userName}}</span>
                                    <button class="btn btn-danger" (click)="deleteWordPressAccount(i.id)">Disconnect</button>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
        </div>
    </div>
  -->
</div>

